<!-- Main view when user is logged in -->
<template>
  <v-app>
    <!-- <Navbar /> -->
    <nav-bar-main />

    <v-main class="ma-4">
      <products />
    </v-main>
    <footer-bar />
  </v-app>
</template>
<script>
//import Navbar from '@/components/main/NavBar';
import FooterBar from '@/components/Main/Footer';
import NavBarMain from '@/components/Main/NavBarMain';
import Products from '@/components/Main/Products.vue';
export default {
  components: {
    //  Navbar,
    FooterBar,
    Products,
    NavBarMain,
  },
  data() {
    return {
      username: '',
    };
  },
  async created() {
    // if (!this.$store.getters.isLoggedIn) {
    //  this.$router.push('/login');
    // }
    this.username = this.$store.getters.getUser.username;
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
  },
};
</script>
